import { inject, Pipe, PipeTransform } from '@angular/core';
import { RoutePathBuilderService } from '../../services/route-path-builder.service';
import { TranslatableSegment } from '../../helpers/translate-segments';
import { Observable } from 'rxjs';

@Pipe({
	name: 'path',
})
export class PathPipe implements PipeTransform {
	private readonly routePathBuilder = inject(RoutePathBuilderService);

	public transform(
		segments: TranslatableSegment[],
		absolutePath = false,
		excludeFragment = false
	): Observable<string[]> {
		return absolutePath
			? this.routePathBuilder.getAbsolute(segments, excludeFragment)
			: this.routePathBuilder.getRelative(segments, excludeFragment);
	}
}
